/**
 * Effective cash for checkout Pay.
 * Empty keypad + zero cashGiven ⇒ exact payment (grandTotal).
 * Any entered amount is used as-is (underpay still blocks Pay in the UI).
 */
export function effectiveCashGiven(
  cashKeypadValue: string,
  cashGiven: number,
  grandTotal: number,
): number {
  const keypadEmpty = !cashKeypadValue.trim();
  if (keypadEmpty && (!Number.isFinite(cashGiven) || cashGiven === 0)) {
    return grandTotal;
  }
  const fromKeypad = parseFloat(cashKeypadValue);
  if (cashKeypadValue.trim() && Number.isFinite(fromKeypad)) {
    return fromKeypad;
  }
  return Number.isFinite(cashGiven) ? cashGiven : 0;
}

export function canConfirmCashPay(
  cashKeypadValue: string,
  cashGiven: number,
  grandTotal: number,
): boolean {
  return effectiveCashGiven(cashKeypadValue, cashGiven, grandTotal) >= grandTotal;
}
